"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/portal_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatReserveItem = exports.SeatSegmentGroup = exports.SeatSegment = exports.Seat = exports.PortalTicketBonusMedia = exports.PortalEvent = exports.SeatUnavailableReason = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.event.v1.SeatUnavailableReason
 */
var SeatUnavailableReason;
(function (SeatUnavailableReason) {
    /**
     * @generated from enum value: SEAT_UNAVAILABLE_REASON_UNSPECIFIED = 0;
     */
    SeatUnavailableReason[SeatUnavailableReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SEAT_UNAVAILABLE_REASON_SOLD_OUT = 1;
     */
    SeatUnavailableReason[SeatUnavailableReason["SOLD_OUT"] = 1] = "SOLD_OUT";
    /**
     * @generated from enum value: SEAT_UNAVAILABLE_REASON_INSUFFICIENT_CONSECUTIVE = 2;
     */
    SeatUnavailableReason[SeatUnavailableReason["INSUFFICIENT_CONSECUTIVE"] = 2] = "INSUFFICIENT_CONSECUTIVE";
})(SeatUnavailableReason || (exports.SeatUnavailableReason = SeatUnavailableReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(SeatUnavailableReason)
protobuf_1.proto3.util.setEnumType(SeatUnavailableReason, "spwn.event.v1.SeatUnavailableReason", [
    { no: 0, name: "SEAT_UNAVAILABLE_REASON_UNSPECIFIED" },
    { no: 1, name: "SEAT_UNAVAILABLE_REASON_SOLD_OUT" },
    { no: 2, name: "SEAT_UNAVAILABLE_REASON_INSUFFICIENT_CONSECUTIVE" },
]);
/**
 * @generated from message spwn.event.v1.PortalEvent
 */
class PortalEvent extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * イベントバナー
         *
         * @generated from field: string event_banner = 3;
         */
        this.eventBanner = "";
        /**
         * イベント詳細
         *
         * @generated from field: string description = 4;
         */
        this.description = "";
        /**
         * ページの公開日時
         *
         * @generated from field: int64 open = 5;
         */
        this.open = protobuf_1.protoInt64.zero;
        /**
         * 開場日時
         *
         * @generated from field: int64 part_open_time = 6;
         */
        this.partOpenTime = protobuf_1.protoInt64.zero;
        /**
         * 配信開始日時
         *
         * @generated from field: int64 part_start_time = 7;
         */
        this.partStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時
         *
         * @generated from field: int64 event_end_time = 8;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalEvent, a, b);
    }
}
exports.PortalEvent = PortalEvent;
PortalEvent.runtime = protobuf_1.proto3;
PortalEvent.typeName = "spwn.event.v1.PortalEvent";
PortalEvent.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "open", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "part_open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "part_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.PortalTicketBonusMedia
 */
class PortalTicketBonusMedia extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 2;
         */
        this.mediaId = "";
        /**
         * アップロードされたファイルの名前
         *
         * @generated from field: string filename = 3;
         */
        this.filename = "";
        /**
         * 特典名
         *
         * @generated from field: string bonus_name = 4;
         */
        this.bonusName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalTicketBonusMedia().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalTicketBonusMedia().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalTicketBonusMedia().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalTicketBonusMedia, a, b);
    }
}
exports.PortalTicketBonusMedia = PortalTicketBonusMedia;
PortalTicketBonusMedia.runtime = protobuf_1.proto3;
PortalTicketBonusMedia.typeName = "spwn.event.v1.PortalTicketBonusMedia";
PortalTicketBonusMedia.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "bonus_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "release_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 6, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.Seat
 */
class Seat extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string seat_id = 1;
         */
        this.seatId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * 座席の状態 "available" | "reserved" | "assigned"
         *
         * @generated from field: string status = 3;
         */
        this.status = "";
        /**
         * 座席の連番を管理するための内部値
         *
         * @generated from field: int32 sort_order = 4;
         */
        this.sortOrder = 0;
        /**
         * @generated from field: int64 created_at = 5;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 updated_at = 6;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Seat().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Seat().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Seat().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(Seat, a, b);
    }
}
exports.Seat = Seat;
Seat.runtime = protobuf_1.proto3;
Seat.typeName = "spwn.event.v1.Seat";
Seat.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "seat_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "order_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "reserved_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "issued_ticket_firestore_path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "assigned_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.SeatSegment
 */
class SeatSegment extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string seat_segment_id = 1;
         */
        this.seatSegmentId = "";
        /**
         * @generated from field: repeated spwn.event.v1.Seat seats = 2;
         */
        this.seats = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SeatSegment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatSegment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatSegment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SeatSegment, a, b);
    }
}
exports.SeatSegment = SeatSegment;
SeatSegment.runtime = protobuf_1.proto3;
SeatSegment.typeName = "spwn.event.v1.SeatSegment";
SeatSegment.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "seat_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seats", kind: "message", T: Seat, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.SeatSegmentGroup
 */
class SeatSegmentGroup extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string seat_segment_group_id = 1;
         */
        this.seatSegmentGroupId = "";
        /**
         * @generated from field: repeated spwn.event.v1.SeatSegment seat_segments = 2;
         */
        this.seatSegments = [];
        /**
         * @generated from field: int64 created_at = 3;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 updated_at = 4;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SeatSegmentGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatSegmentGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatSegmentGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SeatSegmentGroup, a, b);
    }
}
exports.SeatSegmentGroup = SeatSegmentGroup;
SeatSegmentGroup.runtime = protobuf_1.proto3;
SeatSegmentGroup.typeName = "spwn.event.v1.SeatSegmentGroup";
SeatSegmentGroup.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "seat_segment_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seat_segments", kind: "message", T: SeatSegment, repeated: true },
    { no: 3, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.SeatReserveItem
 */
class SeatReserveItem extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        /**
         * @generated from field: int32 count = 3;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SeatReserveItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SeatReserveItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SeatReserveItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(SeatReserveItem, a, b);
    }
}
exports.SeatReserveItem = SeatReserveItem;
SeatReserveItem.runtime = protobuf_1.proto3;
SeatReserveItem.typeName = "spwn.event.v1.SeatReserveItem";
SeatReserveItem.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=portal_common_pb.js.map